export default class ContractAdHocClause {
    public id: number;
    public leaseClauseTypeId?: number;
    public leaseClauseType?: string;
    public clauseText?: string;
    public contractLookupId?: number;
    public leaseId?: number;
}



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAdHocClause.ts